import { useState } from 'react';
import { IoIosArrowDropup, IoIosArrowDropdown } from "react-icons/io";
import { FcApproval } from "react-icons/fc";
import './OriginButton.css';

const OriginButton = ({ dataOriginName, dataOriginChange }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);

    const openOriginMenu = () => {
        setMenuIsOpen(!menuIsOpen);
    }

    const changeOrigin = (newOriginName) => {
        setMenuIsOpen(false);
        dataOriginChange(newOriginName);
    }

    const originNames = ['openweather', 'visualcrossing', 'weatherapi'];

    const OriginOptions = () => (
        originNames.map((origin) =>
            <button key={origin} className="origin__option" onClick={() => changeOrigin(origin)}>
                {dataOriginName === origin && <span className="origin__option--selected"><FcApproval /></span>}
                <span className="origin__option--name">{origin}</span>
            </button>
        )
    )

    return (
        <div className="origin">
            <div className={`origin__menu ${menuIsOpen && 'origin__menu--open'}`}>
                <OriginOptions />
            </div>
            <button className="origin__button" onClick={openOriginMenu}>
                <div className="origin__icon">
                    {menuIsOpen 
                        ? <IoIosArrowDropdown data-testid="origin__icon--arrow-down" /> 
                        : <IoIosArrowDropup data-testid="origin__icon--arrow-up" />
                    }
                </div>
                <p className="origin__text">
                    <span className="origin__text--bold">Fuente:</span>
                    <span className="origin__text--name">{dataOriginName}</span> 
                </p>
            </button>   
        </div>
    );
};
  
export default OriginButton;
